
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/web-hosting",
      function () {
        return require("private-next-pages/services/web-hosting.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/web-hosting"])
      });
    }
  